export const GET_ADMIN_RESTAURANTS = 'GET_ADMIN_RESTAURANTS'
export const GET_ADMIN_SINGLE_RESTAURANT = 'GET_ADMIN_SINGLE_RESTAURANT'
export const GET_ADMIN_RESTAURANTS_FEATURED = 'GET_ADMIN_RESTAURANTS_FEATURED'